import { type SxProps, type Theme } from '@mui/material';

import { MAX_WIDTH } from '@/config/theme/theme.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

import { DRAWER_WIDTH } from '../Layout.tsx';

export const COLLAPSED_DRAWER_WIDTH = 60;

export const getSideBarDrawerClasses = (
  isCollapsed: boolean,
  isHovered: boolean,
): SxProps<Theme> => ({
  '.Mui-selected': {
    background: 'none',
    borderLeft: '4px solid',
    borderLeftColor: themeColors.turquoise,
    color: themeColors.turquoise,
  },
  '& *': {
    overflowX: 'visible',
  },
  background: themeColors.black,
  borderRight: `1px solid ${themeColors.darkGrey}`,
  boxShadow: isCollapsed && isHovered ? '4px 0 8px rgba(0, 0, 0, 0.3)' : 'none',
  color: themeColors.white,
  height: '100dvh',
  left: `max(0px, calc((100vw - ${MAX_WIDTH}) / 2))`,
  overflow: 'hidden',
  position: 'fixed',
  top: 0,
  transition: isCollapsed
    ? 'width 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
    : 'width 0.2s ease-in-out',
  width: isCollapsed && !isHovered ? COLLAPSED_DRAWER_WIDTH : DRAWER_WIDTH,
  zIndex: 1300,
});

export const SideBarListItemButtonStyles: SxProps<Theme> = {
  '&:hover': { background: themeColors.silver_20 },
  height: '48px',
  mb: 1,
  pl: 2,
};

export const SideBarListItemBadgeStyles: SxProps<Theme> = {
  ml: 1,
};
